const jujoEmbedTypesMap = {
  js_code: 'js_code',
  js_url: 'js_url',
}
export default jujoEmbedTypesMap
